import React, { useState } from 'react';
import {
  Button,
  Checkbox,
  ComposedModal,
  Link,
  ModalBody,
  ModalFooter,
} from '@carbon/react';
import './_override.scss';
import { ArrowRight } from '@carbon/react/icons';
import { useNavigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import useUser from '@/lib/hooks/useUser';
/*
const items = [
  {
    heading: 'Erste Schritte',
    copy: `Standort Einrichten und micast-system aktivieren
      hier wird dir erklärt wie du ein Standort einrichtest und dort ein micast system aktivieren kannst.
      `,
    cta: {
      href: '#/welcome/help/firststep',
    },
  },
  {
    heading: 'Stream Einrichten',
    copy: `Erstelle deinen ersten einfachen Stream und lerne das Prinzip von *Streams* und *Elemente* kennen.
      `,
    cta: {
      href: '#/welcome/help/createstream',
    },
  },
  {
    heading: 'Features',
    copy: `Aktiviere Features wie z.B. die Bundesliga anzeige und Streaming für dein micast System.`,
    cta: {
      href: '#/welcome/help/features',
    },
  },
  {
    heading: 'Fortgeschrittene Streams',
    copy:
      'Erstelle ein Stream und verwende den Scheduler um Elemente nur zu bestimmten Zeiten anzuzeigen',
    cta: {
      href: '#/welcome/help/advancedstreams',
    },
  },
];
*/

const infos = `
Willkommen bei **micast**.

Um Dir den Einstieg so einfach wie möglich zu machen, solltest du Dir zunächst die Hilfe-Seite anschauen.

Wir werden zu jedem Inhalt entsprechende Hilfe-Videos und Texte erstellen.


Natürlich kannst Du uns auch jederzeit telefonisch oder per E-Mail erreichen, solltest du weitere Fragen haben.
`;

export const WelcomeModal = ({hideModal}) => {
  const history = useNavigate();

  const [disableInfo, setDisableInfo] = useState(false);

  const {userID} = useUser();

  const goToHelp = () => {
    history('/help');
    hideModal();
  };

  const changeDisableInfo = (e) => {
    setDisableInfo(e);
  };

  const closeModal = () => {
    //TODO: useMutation add disableInfo to update trigger
    if (disableInfo === true) {
      console.info("TODO: disable welcome modal for user", userID);
      //dispatch(userActions.disableWelcomeModal(user.model.ID));
    }

    hideModal();
  };

  return (
    <ComposedModal className="welcome-modal" open={true} onClose={closeModal}>
      <ModalBody>
        <h3>Micast - Der Einstieg</h3>
        <br />
        <div className="cds--content-group__copy">
          <p>
            <ReactMarkdown>
              {infos}
            </ReactMarkdown>
          </p>

          <Link href="#" onClick={() => goToHelp()}>
            MICAST HILFE &gt;
          </Link>
        </div>
      </ModalBody>

      <ModalFooter>
        <Checkbox
          labelText="Meldung nicht erneut anzeigen"
          id={`welcome_form_disable_info`}
          onChange={(_, {checked})  => changeDisableInfo(checked)}
        />

        <Button
          renderIcon={(props) => <ArrowRight size={20} {...props}/>}
          iconDescription="Weiter"
          onClick={closeModal}>
          Weiter
        </Button>
      </ModalFooter>
    </ComposedModal>
  );
};
